import React from "react";
import { PencilIcon } from "assets";
import ProfileButton from "pages/Profile/components/ProfileButton";
import cx from "classnames";

interface Props {
  onClick?: () => void;
  className?: string;
}

const EditButton = ({ onClick, className }: Props) => {
  return (
    <ProfileButton
      onClick={onClick}
      className={cx("min-w-10 rounded-full", className)}
    >
      <PencilIcon />
    </ProfileButton>
  );
};

export default EditButton;
